export const fuelAssetsBaseUrl = 'https://assets.fuel.network/providers/'
